<template>
  <div ref="chart" id="chart"></div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as am4charts from '@amcharts/amcharts4/charts';

export default {
  props: {
    data: {
      required: Array,
      default: [],
    },
  },
  mounted() {
    this.generateGraphics();
  },
  data() {
    return {
      chart: {},
    };
  },
  computed: {
    ...mapGetters([
      'am4core',
    ]),
  },
  methods: {
    generateGraphics() {
      this.chart = this.am4core.create(this.$refs.chart, am4charts.TreeMap);
      this.chart.data = this.data;
      this.chart.dataFields.value = 'value';
      this.chart.dataFields.name = 'name';
      this.chart.layoutAlgorithm = this.chart.binaryTree;
      this.chart.zoomable = false;

      // level 0 series template
      const seriesTemplate = this.chart.seriesTemplates.create('0');
      const columnTemplate = seriesTemplate.columns.template;

      columnTemplate.column.cornerRadius(10, 10, 10, 10);
      columnTemplate.fillOpacity = 1;
      columnTemplate.strokeWidth = 4;
      columnTemplate.stroke = this.am4core.color('#fff');

      const bullet = seriesTemplate.bullets.push(new am4charts.LabelBullet());
      bullet.locationX = 0.5;
      bullet.locationY = 0.8;
      bullet.label.hideOversized = true;
      bullet.label.truncate = true;
      bullet.label.propertyFields.html = 'label';
      bullet.label.fill = this.am4core.color('#fff');
      bullet.interactionsEnabled = false;
      this.chart.maxLevels = 5;
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.chart.data = this.data;
      },
    },
  },
};
</script>
<style scoped>
#chart {
  height: 63vh;
}
</style>




// WEBPACK FOOTER //
// src/components/chat_center_v2/dashboard/Solved/SolvedGraphic.vue